import { documentReady } from './utils';

const backToTop = {
    visibility: false,
    btn: document.querySelector('.js-btn-back-to-top'),
    initialize: () => {

        documentReady(() => backToTop.checkVisibility());

        window.addEventListener('scroll', backToTop.checkVisibility);
    },

    checkVisibility: () => {
        const {scrollY, innerHeight} = window;
        // TODO
        // console.log(scrollY, innerHeight);

        if (scrollY > innerHeight) {
            if (!backToTop.visibility) {
                backToTop.btn.classList.add('is-visible');
                backToTop.visibility = true;
            }
        } else {
            if (backToTop.visibility) {
                backToTop.btn.classList.remove('is-visible');
                backToTop.visibility = false;
            }
        }
    }

}

backToTop.initialize();

export default backToTop;
